import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutThirdFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutThirdFull"><Path d="M3 3V8L21 8V3H3Z" fill="currentColor"/><Path d="M3 14.5V9.5L21 9.5V14.5L3 14.5Z" fill="currentColor"/><Path d="M3 16V21H21V16L3 16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutThirdFull;
